//This is Student.service.js.

//This contains all the service apis to call for backends'  student.controller.js apis

import axios from "axios";

//Env varibale.

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Get all students data.
//Below calls the api from backend.
export const getStudentIfisSlcTakenIsFalse = async () => {
    try {
        // console.log('i am inside service')
        // console.log(API_BASE_URL)   
        const response = await axios.get (`${API_BASE_URL}/api/student`)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}

//Get All students on queryParmas
//Below calls the api from backend.
export const getStudentsByQueryParams = async (queryParams) => {
    try {
     
// Prepare query parameters to send in the URL
const queryString = new URLSearchParams(queryParams).toString();

        const response = await axios.get (`${API_BASE_URL}/api/student-queryparams?${queryString}`)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}








//patch all students All students on queryParmas
//Below calls the api from backend.
export const patchStudentBySrn = async (studentSrn, reqBody) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/api/student/${studentSrn}`,
      reqBody
    );

    return response.data;
  } catch (error) {
    console.error("Error patching student data", error.message);
    throw error;
  }
};



// NEW: upload dress size confirmation PDF
export const uploadDressSizeForm = async (studentSrn, file) => {
  try {
    const formData = new FormData();
    formData.append("dressSizeConfirmationForm", file); // must match multer field name

    const response = await axios.patch(
      `${API_BASE_URL}/api/students/${studentSrn}/dress-size-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // backend returns { status:"Success", message: "...", data: student }
    return response.data;
  } catch (error) {
    console.error("Error uploading dress size form", error.message || error);
    throw error;
  }
};





//Version 2 apis 11-May-2026

export const GetMBStudents = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/get-mb-student-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}




export const GetMBStudentsForAttendance = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/get-mb-students-for-attendance`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}


//Marking student attendance

export const MarkMBStudentAttendance = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/mark-mb-student-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}



//Updating student-absentee calling 
export const StudentAbsenteeCalling = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/mb-student-absentee-callig`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}




//Updating student-absentee calling 
export const StudentAttendanceDashboard = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/mb-student-attendance-dashboard`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}



//Updating student-absentee calling 
export const StudentAbsenteeCallingDashboard = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/mb-student-absentee-calling-dashboard`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}




//GET ALL MB STUDENTS DATA
export const GetAllMbStudentsData = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/get-all-mb-student-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}










//CREATE MB STUDENTS DATA
export const CreateStudent = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/create-mb-student-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}





// // In Student.service.js
// // CREATE MB STUDENTS DATA
// export const CreateStudentFormAPI = async (reqBody) => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/api/create-student-form`, reqBody);
//     return response.data;
//   } catch (error) {
//     console.error("Error creating student:", error);
//     throw error.response?.data || error;
//   }
// };

// // Check SRN availability
// export const checkSRNAvailability = async (srn) => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/api/check-srn-availability`, { studentSrn: srn });
//     return response.data;
//   } catch (error) {
//     console.error("Error checking SRN:", error);
//     throw error.response?.data || error;
//   }
// };





// In Student.service.js
// CREATE MB STUDENTS DATA
export const CreateStudentFormAPI = async (reqBody) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/create-student-form`, reqBody);
    return response.data;
  } catch (error) {
    console.error("Error creating student:", error);
    throw error.response?.data || error;
  }
};

// Check SRN availability
export const checkSRNAvailability = async (srn) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/check-srn-availability`, { studentSrn: srn });
    return response.data;
  } catch (error) {
    console.error("Error checking SRN:", error);
    throw error.response?.data || error;
  }
};






//CREATE MB STUDENTS DATA
export const UpdateStudentBySrn = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/update-mb-student-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}







export const GetStudents = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/get-students`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}







export const DownloadStudentData = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/download-students-data`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}


export const getstudentAddRequest = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/get-student-add-request`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}







export const studentAddUpdatedApi = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/update-student-add-request`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error getting students data", error.message);
        throw error;
    }
}










export const updateDressSize = async (reqBody) => {
    try {
     
        const response = await axios.post (`${API_BASE_URL}/api/update-dress-size`,reqBody)
        
        return response.data;


    } catch (error) {
        console.error("Error updating dress size students data", error.message);
        throw error;
    }
}











